module.exports = __webpack_public_path__ + "media/images/mailer/feedback-48-primary-c5df70d74cbcc744b0b2a9135851eeb4.png";